module.exports = __webpack_public_path__ + "img/first-left.f1f45c75.png";